import {
  focusArticle,
  loadAsset,
  loadBanner,
  loadCategory,
  loadHomeArticle,
  loadTabArticle,
  loadWalletBounty,
} from './action';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface IinitialState {
  asset: {
    productList?: Array<any>;
    sumOfInterestOrHole?: number | string;
    sumOfValueCurrently?: number;
    sumOfValueInvested?: number;
  };
  banner: Array<any>;
  loading: boolean;
  walletBounty: any;
  articleFocus: any;
  article: any;
  loadingArticleFocus: boolean;
  pagination: any;
  category: Array<any>;
}
const initialState = {
  loading: false,
  asset: {},
  banner: [],
  walletBounty: {},
  articleFocus: null,
  loadingArticleFocus: false,
  article: {},
  pagination: {},
  category: [],
} as IinitialState;

const asset = createSlice({
  name: 'asset',
  initialState: initialState,
  reducers: {
    clearAsset(state, action: PayloadAction<any>) {
      state.loading = false;
      state.asset = {};
    },
    changeFocusArticle(state, action: PayloadAction<any>) {
      state.articleFocus = action.payload;
    },
  },
  extraReducers: builder => {
    //load morehistore
    builder.addCase(loadAsset.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(loadAsset.fulfilled, (state, action) => {
      state.loading = false;
      state.asset = action.payload;
    });
    builder.addCase(loadAsset.rejected, (state, action) => {
      state.loading = false;
    });
    //load banner
    builder.addCase(loadBanner.pending, (state, action) => {});
    builder.addCase(loadBanner.fulfilled, (state, action) => {
      state.banner = action.payload;
    });
    builder.addCase(loadBanner.rejected, (state, action) => {});
    //load bounty
    builder.addCase(loadWalletBounty.pending, (state, action) => {});
    builder.addCase(loadWalletBounty.fulfilled, (state, action) => {
      state.walletBounty = action.payload;
    });
    //load hgome category
    builder.addCase(loadCategory.pending, (state, action) => {});
    builder.addCase(loadCategory.fulfilled, (state, action) => {
      state.category = action.payload;
    });
    // load article
    builder.addCase(loadHomeArticle.pending, (state, action) => {});
    builder.addCase(loadHomeArticle.fulfilled, (state, action) => {
      state.article = {
        ...state.article,
        [`home`]: action.payload,
      };
    });
    builder.addCase(loadHomeArticle.rejected, (state, action) => {});
    //load focus article
    builder.addCase(focusArticle.pending, (state, action) => {
      state.loadingArticleFocus = true;
    });
    builder.addCase(focusArticle.fulfilled, (state, action) => {
      state.articleFocus = action.payload.details;
      state.article = {
        ...state.article,
        [`details`]: action.payload.lstArticle,
      };
      state.loadingArticleFocus = false;
    });
    builder.addCase(focusArticle.rejected, (state, action) => {
      state.loadingArticleFocus = false;
    });
    //load article tab
    builder.addCase(loadTabArticle.pending, (state, action) => {});
    builder.addCase(loadTabArticle.fulfilled, (state, action) => {
      state.article = {
        ...state.article,
        [`${action.payload.category.code}`]: action.payload.items,
      };
      state.pagination = {
        ...state.pagination,
        [`${action.payload.category.code}`]: action.payload.pagination,
      };
    });
  },
});
const {actions, reducer} = asset;
export const {clearAsset, changeFocusArticle} = actions;
export default reducer;
